<div class="container-fluid my-5 main-declare">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active" aria-current="page"> / AJOUTER UNE NOUVELLE CAS D'INFECTION</li>
        </ol>
    </nav>

    <div class="container  ">
        
        <diV class="call-for-help">
            <form [formGroup]="newcase" (ngSubmit)="sendDeclaration($event)">
    
    
                <div class="form-group">
                  <label ><i class="fas fa-user-alt"></i> PRÉNOM ET NOM </label>
                  <input type="text" class="form-control"  placeholder="PRÉNOM ET NOM" name="fullname" formControlName="fullname" >
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-phone"></i> TÉLÉPHONE </label>
                    <input type="text" class="form-control"  placeholder="TÉLÉPHONE" name="phone" formControlName="phone" >
                </div>

                <div class="form-group">
                    <label ><i class="fas fa-arrow-location"></i> RÉGION ( المنطقة )</label>
                    <select class="form-control" name="region" formControlName="region">
                        <option value="Ariana - أريانة">Ariana - أريانة</option>
                        <option value="Béja - باجة">Béja - باجة</option>
                        <option value="Ben Arous - بن عروس">Ben Arous - بن عروس</option>
                        <option value="Bizerte - بنزرت">Bizerte - بنزرت</option>
                        <option value="Gabès - قابس">Gabès - قابس</option>
                        <option value="Gafsa - قفصة">Gafsa - قفصة</option>
                        <option value="Kairouan - القيروان">Kairouan - القيروان</option>
                        <option value="Jendouba - جندوبة">Jendouba - جندوبة</option>
                        <option value="Kasserine - القصرين">Kasserine - القصرين</option>
                        <option value="Kébili - قبلي">Kébili - قبلي</option>
                        <option value="Le Kef - الكاف">Le Kef - الكاف</option>
                        <option value="Mahdia - المهدية">Mahdia - المهدية</option>
                        <option value="Manouba - منوبة">Manouba - منوبة"</option>
                        <option value="Médenine - مدنين">Médenine - مدنين</option>
                        <option value="Monastir - المنستير">Monastir - المنستير</option>
                        <option value="Nabeul - نابل">Nabeul - نابل</option>
                        <option value="Sfax - صفاقس">Sfax - صفاقس</option>
                        <option value="Sidi Bouzid - سيدي بوزيد">Sidi Bouzid - سيدي بوزيد</option>
                        <option value="Siliana - سليانة">Siliana - سليانة</option>
                        <option value="Sousse - سوسة">Sousse - سوسة</option>
                        <option value="Tataouine - تطاوين">Tataouine - تطاوين</option>
                        <option value="Tozeur - توزر">Tozeur - توزر</option>
                        <option value="Tunis - تونس">Tunis - تونس</option>
                        <option value="Zaghouan - زغوان">Zaghouan - زغوان</option>
                    </select>
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-male"></i> <i class="fas fa-female"></i>  SEXE </label>
                    <select class="form-control" name="sex" formControlName="sex">
                        <option value="1">MÂLE </option>
                        <option value="2">FEMELLE </option>
                        
                    </select>
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-clock"></i>  ÂGE </label>
                    <input type="text" class="form-control"  placeholder="ÂGE" name="age" formControlName="age" >
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-calendar"></i>  DATE </label>
                    <input type="date" class="form-control"  placeholder="ÂGE" name="age" formControlName="date" >
                </div>

                <h6>
                    SUR LA CARTE ( cliquez sur la carte pour sélectionner la zone infectée)
                </h6>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label ><i class="fas fa-map"></i>  longitude </label>
                            <input type="text" class="form-control"  placeholder="longitude" name="longitude" formControlName="lng" >
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                                <label ><i class="fas fa-map"></i>  latitude </label>
                                <input type="text" class="form-control"  placeholder="latitude" name="latitude" formControlName="lat" >
                            
                        </div>
                    </div>
                    
                </div>

                <div class="map" id="map"></div>
                
                
                <div class="btns-block-new-case" *ngIf="!isLoading">
                    <button type="submit" class="btn btn-primary"   style="margin-right: 15px;margin-bottom:15px" [disabled]="! newcase.valid" >ENVOYER </button>
                    <button type="reset" class="btn btn-secondary" routerLink="/rns-admin" style="margin-right: 15px;margin-bottom:15px">ANNULER</button>
                </div>
                <div class="btns-block-new-case" *ngIf="isLoading">
                    <div class="alert alert-info">
                        ENVOI DE LA DEMANDE AUX SERVEURS ...
                    </div>
                </div>
                <div class="btns-block-new-case" *ngIf="! isLoading">
                    <div class="alert alert-danger" *ngIf="errorMessage.length !=0">
                        {{errorMessage}}
                    </div>
                    <div class="alert alert-success" *ngIf="requestSent">
                        {{successMessage}}
                    </div>
                    
                    
                </div>
                
                
                

              </form>
        </diV>
    
    </div>